import { AttachmentResponse } from "../contracts/AttachmentResponse";
import { MessageAttachment } from "../models/MessageAttachment";

/** Maps an attachment from the API to the frontend model. */
export const toMessageAttachment = (response: AttachmentResponse): MessageAttachment => ({
  id: response.id,
  kind: response.kind,
  fileName: response.fileName,
  contentType: response.contentType,
  sizeBytes: response.sizeBytes,
  width: response.width ?? null,
  height: response.height ?? null,
  fromMaterial: response.fromMaterial,
});
